import * as C from "../constants"
import { createReducer} from "../utils/misc";

const initialState = {
    invalidKeys: {
        data: [],
        count: null,
        isLoading: false,
        isLoaded: false
    },
    keys: {
        data: [],
        count: null,
        isLoading: false,
        isLoaded: false,
    },
    key_types: {
        data: [],
        count: null,
        isLoading: false,
        isLoaded: false,
    },
    key: {
        data: null,
        isLoaded: false,
        isLoading: false,
    },
    key_transactions: {
        data: [],
        isLoaded: false,
        isLoading: false,
        count: null,
        page: null,
        pages: null,
    }
};

export default createReducer(initialState, {
   [C.INVALID_KEYS_REQUEST]: (state) => ({
       ...state,
       invalidKeys: {
           ...state.invalidKeys,
           isLoading: true,
       },
   }),
   [C.INVALID_KEYS_FAILURE]: (state) => ({
       ...state,
       invalidKeys: {
           ...state.invalidKeys,
           isLoading: false,
           isLoaded: false,
       },
   }),
   [C.INVALID_KEYS_SUCCESS]: (state, payload) => ({
       ...state,
       invalidKeys: {
           ...state.invalidKeys,
           isLoading: false,
           isLoaded: true,
           data: payload.invalidKeys,
           count: payload.count,
           page: payload.page,
           pages: payload.pages,
       }
   }),
   [C.GET_KEYS_REQUEST]: (state) => ({
       ...state,
       keys: {
           ...state.keys,
           isLoading: true,
       }
   }),
    [C.GET_KEYS_FAILURE]: (state) => ({
        ...state,
        keys: {
            ...state.keys,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка ключей."
    }),
    [C.GET_KEYS_SUCCESS]: (state, payload) => ({
        ...state,
        keys: {
            ...state.keys,
            isLoading: false,
            isLoaded: true,
            data: payload.keys,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
        }
    }),
    [C.CREATE_KEY]: (state, payload) => ({
        ...state,
        keys: {
            ...state.keys,
            data: [
                ...state.keys.data,
                payload
            ].sort((a, b) => (a.id > b.id ? 1 : -1)),
            count: state.keys.count + 1
        }
    }),
    [C.CREATE_KEY_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка создания ключа."
    }),
    [C.EDIT_KEY]: (state, payload) => {
       const newKeys = state.keys.data.map(key => (key.id !== payload.id ? key : payload));
       console.log("newKeys",newKeys);
       return {
        ...state,
        keys: {
            ...state.keys,
            data: newKeys,
        }
    }},

    [C.EDIT_KEY_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка редактирования ключа."
    }),
    [C.DELETE_KEY]: (state, payload) => ({
        ...state,
        keys: {
            ...state.keys,
            data: state.keys.data.map(key => (key.id !== payload ? key : null)).filter(n => n),
            count: state.keys.count - 1,
        }
    }),
    [C.GET_KEY_TYPES_REQUEST]: (state) => ({
        ...state,
        key_types: {
            ...state.key_types,
            isLoading: true,
        }
    }),
    [C.GET_KEY_TYPES_FAILURE]: (state) => ({
        ...state,
        key_types: {
            ...state.key_types,
            isLoading: false,
            isLoaded: false
        },
        statusText: "Ошибка загрузки списка типов ключей."
    }),
    [C.GET_KEY_TYPES_SUCCESS]: (state, payload) => ({
        ...state,
        key_types: {
            ...state.key_types,
            data: payload,
            count: payload.count,
            isLoading: false,
            isLoaded: true,
        }
    }),
    [C.GET_KEY_REQUEST]: (state) => ({
        ...state,
        key: {
            ...state.key,
            isLoading: true
        }
    }),
    [C.GET_KEY_FAILURE]: (state) => ({
        ...state,
        key: {
            ...state.key,
            isLoading: false,
            isLoaded: false
        },
        statusText: "Ошибка загрузки данных ключа"
    }),
    [C.GET_KEY_SUCCESS]: (state, payload) => ({
        ...state,
        key: {
            ...state.key,
            data: payload,
            isLoading: false,
            isLoaded: true,
        }
    }),
    [C.GET_KEY_TRANSACTION_REQUEST]: (state) => ({
        ...state,
        key_transactions: {
            ...state.key_transactions,
            isLoading: true,
        }
    }),
    [C.GET_KEY_TRANSACTION_FAILURE]: (state) => ({
        ...state,
        key_transactions: {
            ...state.key_transactions,
            isLoading: false,
            isLoaded: false
        }
    }),
    [C.GET_KEY_TRANSACTION_SUCCESS]: (state, payload) => ({
        ...state,
        key_transactions: {
            ...state.key_transactions,
            data: payload.key_transactions,
            isLoading: false,
            isLoaded: true,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
        }
    })
});


// WEBPACK FOOTER //
// ./src/reducers/keys.js